import React from 'react';
import Autosuggest from 'react-autosuggest';

import { generalHelpers } from '../../../helpers';
import { useSourceLinkSearchHistory } from '../../../hooks/useSearchHistory';

// always render suggestion even if user only type 1 char
const shouldRenderSuggestions = () => true;

interface Props {
  value: string;
  onChange: (stockCode: string) => void;
  renderInputComponent: (props: never) => React.ReactNode; // We don't have to know about this prop in this component
  onKeyPress?: (e: KeyboardEvent) => void;
}

const SourceLinkInput: React.FC<Props> = ({
  value,
  onChange,
  renderInputComponent,
  onKeyPress,
}) => {
  const searchHistory = useSourceLinkSearchHistory(value);

  const renderSuggestion = suggestion => {
    return <div>{suggestion.tipsSourceLink}</div>;
  };
  // duplicated with InfluencerInput but this is how autosuggest being implemented
  // jscpd:ignore-start
  const onSuggestionSelected = (_, { suggestionValue }) => {
    onChange(suggestionValue);
  };

  const onChangeInternal = (_, { newValue }) => {
    onChange(newValue);
  };

  return (
    <Autosuggest
      inputProps={{
        value: value || '',
        onChange: onChangeInternal,
        onKeyPress: onKeyPress,
      }}
      suggestions={searchHistory}
      onSuggestionsFetchRequested={generalHelpers.noop}
      onSuggestionsClearRequested={generalHelpers.noop}
      renderSuggestion={renderSuggestion}
      getSuggestionValue={suggestion => suggestion.tipsSourceLink}
      onSuggestionSelected={onSuggestionSelected}
      renderInputComponent={renderInputComponent}
      shouldRenderSuggestions={shouldRenderSuggestions}
    />
  );
};

export default SourceLinkInput;
// jscpd:ignore-end
